import { AlertOctagon, AlertTriangle } from 'lucide-react';

import type { JSX } from 'react';

export interface PendencyBannersProps {
  /** Pendências vencidas (derivado do carregado). */
  overdueCount: number;
  /** Pendências que atingiram o limite de adiamentos (postponeCount >= 3). */
  maxPostponeCount: number;
  /** Callback opcional "Ver vencidas" — a página filtra a janela `overdue`. */
  onViewOverdue?: () => void;
}

/**
 * Banners da Tela 3 (Brief 2B §8.11) — derivados, honestos:
 *   - Vencidas (danger): overdueCount > 0.
 *   - Max-postpone (warning): maxPostponeCount > 0 (supervisor notificado).
 *
 * O flourish "Operação Regulada" do mockup depende do conceito de variant
 * (derivado em outro ponto do app) — omitido aqui (honest-defer).
 */
export function PendencyBanners({
  overdueCount,
  maxPostponeCount,
  onViewOverdue,
}: PendencyBannersProps): JSX.Element | null {
  if (overdueCount <= 0 && maxPostponeCount <= 0) return null;

  return (
    <div className="flex flex-col gap-2 px-6 pt-3" aria-live="polite">
      {overdueCount > 0 && (
        <div className="banner-2b banner-2b--danger" role="alert">
          <AlertOctagon className="banner-2b__icon" aria-hidden />
          <div className="banner-2b__msg">
            <strong>
              {overdueCount} pendência{overdueCount > 1 ? 's' : ''} vencida
              {overdueCount > 1 ? 's' : ''}
            </strong>{' '}
            — agir agora antes de novas atribuições.
          </div>
          {onViewOverdue !== undefined && (
            <button
              type="button"
              className="btn btn--destructive-solid btn--sm"
              onClick={onViewOverdue}
            >
              Ver vencidas
            </button>
          )}
        </div>
      )}
      {maxPostponeCount > 0 && (
        <div className="banner-2b banner-2b--warning" role="alert">
          <AlertTriangle className="banner-2b__icon" aria-hidden />
          <div className="banner-2b__msg">
            <strong>
              {maxPostponeCount} pendência{maxPostponeCount > 1 ? 's' : ''} atingiu o máximo de
              adiamentos
            </strong>{' '}
            — supervisor notificado.
          </div>
        </div>
      )}
    </div>
  );
}
